import React, { createContext, useState } from 'react'

export const StepContext = createContext(null)

export const Provider = ({ children }) => {
  const [value, setValue] = useState(null)

  return (
    <StepContext.Provider
      value={{
        value,
        setValue,
      }}
    >
      {children}
    </StepContext.Provider>
  )
}
